import { Theme } from '@mui/material/styles'

const useStyles = {
  header: (theme: Theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    height: '84px',
  }),
  headerLogo: {
    display: 'inline-block',
    height: '37px',
  },
  headerLogoLink: {
    textDecoration: 'none',
    color: 'inherit',
  },
  toolbar: (theme: Theme) => ({
    maxWidth: theme.breakpoints.values.xl,
    width: '100%',
    margin: 'auto',
  }),
  menuPaper: (theme: Theme) => ({
    minWidth: '200px',
    overflow: 'visible',
    marginTop: theme.spacing(1),
  }),
  menuUserInfo: (theme: Theme) => ({
    display: 'block',
    padding: theme.spacing(1.5, 2),
    // this menu item is `disabled` but we want the opacity to still be 1
    '&&': {
      opacity: 1,
    },
  }),
  menuEmail: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  backdrop: (theme: Theme) => ({
    color: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0,0,0,0.8)',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  }),
  backdropSearchTitle: (theme: Theme) => ({
    marginTop: '134px',
    marginBottom: theme.spacing(3),
  }),
  backdropSearchContainer: (theme: Theme) =>
    ({
      width: `calc(100% - ${theme.spacing(8)})`,
      marginX: theme.spacing(4),
      maxWidth: '930px',
    }) as const,
  backdropCloseIconButton: (theme: Theme) => ({ position: 'absolute', right: 0, color: theme.palette.common.white }),
  backdropCloseIcon: { fontSize: '60px' },
}
export default useStyles
